<template>
  <option-general value="interval_until_action" :label="$t('edit.sidebar.interval_until_action')">
    <div class="box-input-group">
      <input
        class="box-input"
        type="number"
        :value="boxConfig.advanced.exibition_frequency_interval_value"
        @change="boxUpdateConfig({ item: 'advanced', key: 'exibition_frequency_interval_value', value: $event.target.value });">
      <span class="box-input-group-label">{{ $t('general.labels.days') }}</span>
    </div>
  </option-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OptionGeneral from './general/Main.vue';

export default {
  components: {
    OptionGeneral,
  },
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>
exibition_mode_time_value



/** WEBPACK FOOTER **
 ** IntervalUntilAction.vue?4ad48f91
 **/